/**
 * Constantes para busca de músicas
 */
import { BIBLICAL_BOOKS } from './biblicalBooks';
import { removeAccents } from '@/utils/stringUtils';

/**
 * Lista de livros bíblicos normalizados para busca (com e sem acento)
 * Usado para detectar quando o usuário está buscando por um livro bíblico
 */
export const BIBLICAL_BOOKS_SEARCH_VARIANTS = [
  // Pentateuco
  'genesis', 'gênesis', 'exodo', 'êxodo', 'levitico', 'levítico', 'numeros', 'números', 'deuteronomio', 'deuteronômio',
  // Históricos
  'josue', 'josué', 'juizes', 'juízes', 'rute', '1samuel', '1 samuel', '2samuel', '2 samuel', '1reis', '1 reis', '2reis', '2 reis',
  '1cronicas', '1 crônicas', '1crônicas', '2cronicas', '2 crônicas', '2crônicas', 'esdras', 'neemias', 'ester',
  // Poéticos
  'jo', 'jó', 'salmos', 'salmo', 'proverbios', 'provérbios', 'eclesiastes', 'cantares', 'cânticos',
  // Profetas Maiores
  'isaias', 'isaías', 'jeremias', 'lamentacoes', 'lamentações', 'ezequiel', 'daniel',
  // Profetas Menores
  'oseias', 'oséias', 'joel', 'amos', 'amós', 'obadias', 'jonas', 'miqueias', 'miquéias', 'naum', 'habacuque', 'sofonias', 'ageu', 'zacarias', 'malaquias',
  // Evangelhos e Atos
  'mateus', 'marcos', 'lucas', 'joao', 'joão', 'atos',
  // Cartas Paulinas
  'romanos', '1corintios', '1 corintios', '1coríntios', '1 coríntios', '2corintios', '2 corintios', '2coríntios', '2 coríntios',
  'galatas', 'gálatas', 'efesios', 'efésios', 'filipenses', 'colossenses', '1tessalonicenses', '1 tessalonicenses', '2tessalonicenses', '2 tessalonicenses',
  '1timoteo', '1 timoteo', '1timóteo', '1 timóteo', '2timoteo', '2 timoteo', '2timóteo', '2 timóteo', 'tito', 'filemom',
  // Cartas Gerais
  'hebreus', 'tiago', '1pedro', '1 pedro', '2pedro', '2 pedro', '1joao', '1 joao', '1joão', '1 joão',
  '2joao', '2 joao', '2joão', '2 joão', '3joao', '3 joao', '3joão', '3 joão', 'judas',
  // Apocalipse
  'apocalipse'
] as const;

/**
 * Verifica se um termo de busca corresponde a um livro bíblico
 * @param searchTerm - Termo de busca normalizado
 * @returns true se for um livro bíblico
 */
export function isBiblicalBookSearch(searchTerm: string): boolean {
  const normalized = removeAccents(searchTerm.toLowerCase());
  return BIBLICAL_BOOKS_SEARCH_VARIANTS.some(book => removeAccents(book) === normalized);
}

/**
 * Verifica se é uma busca por Salmos
 * @param searchTerm - Termo de busca normalizado
 * @returns true se for busca por salmos
 */
export function isSalmoSearch(searchTerm: string): boolean {
  const normalized = removeAccents(searchTerm.toLowerCase());
  return ['salmo', 'salmos'].includes(normalized);
}

/**
 * Exporta a lista de livros bíblicos para uso em outros lugares
 */
export { BIBLICAL_BOOKS };

